import * as openpgp from 'openpgp'

async function encryptImage(
  imageFile: File,
  password: string,
): Promise<string> {
  // Instead of base64, we can use Uint8Array for binary data
  const arrayBuffer = await imageFile.arrayBuffer()
  const binaryData = new Uint8Array(arrayBuffer)

  // Encrypt the binary data directly
  const message = await openpgp.createMessage({ binary: binaryData })
  const encrypted = await openpgp.encrypt({
    message,
    passwords: [password],
    format: 'binary', // Use binary instead of armored (text) format
  })

  // Convert to base64 only if needed for transport
  return btoa(
    Array.from(new Uint8Array(encrypted as Uint8Array))
      .map((byte) => String.fromCharCode(byte))
      .join(''),
  )
}

// async function encryptImage(
//   imageFile: File,
//   password: string,
// ): Promise<string> {
//   const reader = new FileReader()
//   const base64Promise = new Promise<string>((resolve) => {
//     reader.onload = function () {
//       resolve((reader.result as string).split(',')[1])
//     }
//     reader.readAsDataURL(imageFile)
//   })
//   const base64String = await base64Promise
//   const dataToEncrypt = JSON.stringify({
//     data: base64String,
//     mimeType: imageFile.type,
//   })
//   const message = await openpgp.createMessage({ text: dataToEncrypt })
//   const encrypted = await openpgp.encrypt({
//     message,
//     passwords: [password],
//     format: 'armored',
//   })

//   return encrypted as string
// return new Promise((resolve, reject) => {
//   const reader = new FileReader()
//   reader.onload = function () {
//     try {
//       const base64String = (reader.result as string).split(',')[1]
//       const dataToEncrypt = JSON.stringify({
//         data: base64String,
//         mimeType: imageFile.type, // File object contains the MIME type
//       })
//       const encrypted = CryptoJS.AES.encrypt(dataToEncrypt, password)

//       resolve(encrypted.toString())
//     } catch (error) {
//       reject(error)
//     }
//   }
//   reader.readAsDataURL(imageFile)
// })
// }

export default encryptImage
